(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cricketeria-mega-menu"] && !Shopify.designMode) return;
  try {
    
  class CricketeriaMenu extends HTMLElement {
    constructor() {
      super();
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.tabs = [...this.querySelectorAll('.cmega__tab')];
      this.panels = [...this.querySelectorAll('.cmega__panel')];
      this.toggleBtn = this.querySelector('[data-menu-toggle]');
      this.overlay = this.querySelector('[data-menu-close]');

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.onTabClick(tab));
        if (this.desktop.matches) {
          tab.addEventListener('mouseenter', () => this.open(tab));
          tab.addEventListener('focus', () => this.open(tab));
        }
      });

      this.addEventListener('mouseleave', () => {
        if (this.desktop.matches) this.closeAll();
      });
      this.toggleBtn?.addEventListener('click', () => this.toggleDrawer());
      this.overlay?.addEventListener('click', () => this.toggleDrawer(false));
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAll();
          this.toggleDrawer(false);
        }
      });
    }

    panelFor(tab) {
      return this.querySelector('#' + tab.getAttribute('aria-controls'));
    }

    open(tab) {
      this.tabs.forEach((t) => t.setAttribute('aria-expanded', String(t === tab)));
      this.panels.forEach((p) => {
        p.hidden = p !== this.panelFor(tab);
      });
    }

    closeAll() {
      this.tabs.forEach((t) => t.setAttribute('aria-expanded', 'false'));
      this.panels.forEach((p) => {
        p.hidden = true;
      });
    }

    onTabClick(tab) {
      const isOpen = tab.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        this.closeAll();
      } else {
        this.open(tab);
        // On mobile, move the panel right after the tab so it reads as an accordion
        if (!this.desktop.matches) {
          const panel = this.panelFor(tab);
          tab.after(panel);
        }
      }
    }

    toggleDrawer(force) {
      const next = force ?? !this.classList.contains('is-open');
      this.classList.toggle('is-open', next);
      this.toggleBtn?.setAttribute('aria-expanded', String(next));
      if (this.overlay) this.overlay.hidden = !next;
      document.body.style.overflow = next ? 'hidden' : '';
      if (!next) this.closeAll();
    }
  }
  customElements.define('cricketeria-menu', CricketeriaMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
